export const leavesEmployee = [
    {
        "empId": "POS001",
        "type": "Sick Leave",
        "date": "02 Aug 2023",
        "duration": "01 Day",
        "appliedOn": "04 Aug 2023",
        "reason": "",
        "approval": "Applied",
        "action": ""
      },
      {
        "empId": "POS002",
        "type": "Paternity",
        "date": "07 Aug 2023",
        "duration": "2 hrs",
        "appliedOn": "07 Aug 2023",
        "reason": "",
        "approval": "Approved",
        "action": ""
      },
      {
        "empId": "POS003",
        "type": "Sick Leave",
        "date": "03 Aug 2023",
        "duration": "01 Day",
        "appliedOn": "03 Aug 2023",
        "reason": "Reason",
        "approval": "Rejected",
        "action": "Rejected"
      },
      {
        "empId": "POS004",
        "type": "Sick Leave",
        "date": "05 Aug 2023",
        "duration": "01 Day",
        "appliedOn": "05 Aug 2023",
        "reason": "Reason",
        "approval": "Rejected",
        "action": "Rejected"
      },
      {
        "empId": "POS005",
        "type": "Sick Leave",
        "date": "08 Aug 2023",
        "duration": "02 Days",
        "appliedOn": "08 Aug 2023",
        "reason": "",
        "approval": "Applied",
        "action": "Applied"
      },
      {
        "empId": "POS006",
        "type": "Sick Leave",
        "date": "03 Aug 2023",
        "duration": "2 hrs",
        "appliedOn": "03 Aug 2023",
        "reason": "",
        "approval": "Approved",
        "action": ""
      }
]